import srilakshmi from '../assets/home/trvto_srilakshmi.jpg';
import sumita from '../assets/home/trvto_sumita.jpg';
import prerana from '../assets/home/trvto_prerana.jpg';
import vijay from '../assets/home/trvto_vijay.jpg';
import shashi from '../assets/home/trvto_shashi.jpg';

export const ReviewsData = [
    {
        id: 1,
        image: sumita,
        rating: 5,
        title: 'Perfect for Weekend Getaways',
        description:
            'Trvto is now my go-to for planning weekend escapes. The platform helped me find offbeat, thrilling experiences close to home. I’ve done two trips so far – one to a remote hiking trail and one for backpacking. Both were well-curated and absolutely refreshing',
        author: 'Sumita',
        designation: 'Bengaluru'
    },
    {
        id: 2,
        image: vijay,
        rating: 5,
        title: 'A one-stop hub for adventure seekers.',
        description:
            'This website is perfect for thrill-seekers like me! I booked a trekking trip to the Himalayas, and the range of adventures available was mind-blowing. The filters helped me narrow down options based on difficulty level and safety measures. With expert guides ensuring our safety and authentic experiences, it felt like the trip was curated just for us.',
        author: 'Vijay',
        designation: 'Bengaluru'
    },
    {
        id: 3,
        image: srilakshmi,
        rating: 5,
        title: 'Safety and trust redefined!',
        description:
            'I was hesitant to book a solo trip, but this website’s transparency and detailed reviews put my mind at ease. Their partnerships with trustworthy organizers ensured a safe and enjoyable experience. The customer support team was responsive, which added to my confidence in the platform. Truly a game-changer for solo travelers.',
        author: 'Srilakshmi',
        designation: 'Bengaluru'
    },
    {
        id: 4,
        image: prerana,
        rating: 5,
        title: 'Community + Adventure = Trvto!',
        description:
            'The best part about Trvto is the community vibe. It’s not just about travel – it’s about connecting with people who share your love for adventure. I joined a monsoon trek and ended up making new friends, all while exploring scenic trails I had never heard of before.',
        author: 'Prerana',
        designation: 'Bengaluru'
    },
    {
        id: 5,
        image: shashi,
        rating: 5,
        title: 'A Game-Changer for Adventure Seekers!',
        description:
            'Trvto made it incredibly easy to discover and join authentic hiking trips. I loved how seamlessly I could connect with like-minded travelers and book unique adventures. The trip I joined was well-organized and full of unforgettable moments!',
        author: 'Shashi',
        designation: 'Bengaluru'
    }
];
